import { fetchElementMetadata } from "@/services/assets/services"
import type { IWebCOOSElement } from "@/services/assets/types"
import { useTimeSeriesAssetBrowse } from "@/services/media/useTimeSeriesAssetBrowse"
import { useAPIContext } from "@/state/ApiContext"
import { ViewWithLoader } from "@axdspub/axiom-ui-utilities"
import { useQuery } from "@tanstack/react-query"
import type { ReactElement } from "react"

const DefaultElementView = ({ element }: { element: IWebCOOSElement }): ReactElement => {
    return <img src={element.data.properties.url} className='mx-auto' />
}


export const NearestElementLoader = ({
    date,
    serviceIdentifier,
    View = DefaultElementView
}: {
    date: Date,
    serviceIdentifier: string,
    View: React.FC<{ element: IWebCOOSElement }>
}): ReactElement => {
    const apiContext = useAPIContext()
    const { data, isLoading, error } = useTimeSeriesAssetBrowse({
        ...apiContext,
        serviceIdentifier,
        ...apiContext,
        date,
        direction: 'nearest',
        count: 1

    })
    return <ViewWithLoader data={data} isLoading={isLoading} error={error}>
        {
            data &&
            <View element={data as IWebCOOSElement} />
        }
    </ViewWithLoader>

}

const ElementLoader = ({
    elementIdentifier,
    View = DefaultElementView
}: {
    elementIdentifier: string
    View: React.FC<{ element: IWebCOOSElement }>
}): ReactElement => {
    const apiContext = useAPIContext()

    const { data, isLoading, error } = useQuery({
        queryKey: ['element-metadata', elementIdentifier],
        queryFn: async ({ signal }): Promise<IWebCOOSElement> => {
            const element = await fetchElementMetadata({
                ...apiContext,
                signal,
                elementIdentifier
            })
            return element
        }
    })

    return <ViewWithLoader data={data} isLoading={isLoading} error={error} keepExistingContentWhileLoading={true}>
        {
            data &&
            <View element={data} />
        }

    </ViewWithLoader>

}

export default ElementLoader